import React from 'react';
import Data from '../database/data.json';


const Project = () => {
 
  return (
    <>
    <div className='projectFile' >
      {
          Data.reverse().map(({name,image,link},index)=>{
              return (
                <div className='projectName' key={index}>
                                   <h3>{name}</h3>
                                  <img className='projectImage' src={image} alt={name}/>
                                  <a href={link}>View</a>
                           </div>
              
              )
          })
         
      }
       </div>
    </>
  )
}

export default Project
